import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { ApplicationCollectionFeatureComponent } from './application-collection-feature.component';
import { CollectionFiltersComponent } from './components/collection-filters/collection-filters.component';
import { CollectionCardComponent } from './components/collection-card/collection-card.component';
import { CollectionMapComponent } from './components/collection-map/collection-map.component';
import { CollectionFilterService } from './collection-filter.service';
import { CollectionMapService } from './collection-map.service';

@NgModule({
  declarations: [
    ApplicationCollectionFeatureComponent,
    CollectionFiltersComponent,
    CollectionCardComponent,
    CollectionMapComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatSliderModule,
    MatIconModule,
    MatDatepickerModule,
    TranslateModule,
    SharedModule,
  ],
  providers: [
    CollectionFilterService,
    CollectionMapService,
  ],
  exports: [
    ApplicationCollectionFeatureComponent,
  ],
})
export class ApplicationCollectionModule {}
